import { ActionTree } from 'vuex'
import { FoldersState } from './folders.model'
import { MutationTypes } from './folders.mutations'
import { authenticatedApolloClient } from '@/services/authenticated-apollo.service'
import getCompanySharedFolders from '@/graphql/queries/getCompanySharedFolders'
import { GetCompanySharedFoldersQuery, GetCompanySharedFoldersQueryVariables } from '@/graphql/generated/types'

export const actions: ActionTree<FoldersState, unknown> = {
  async GET_FOLDERS({ commit }, id: string) {
    try {
      commit(MutationTypes.GET_FOLDERS_REQUEST)
      const {
        data: { getCompanySharedFolders: folders }
      } = await authenticatedApolloClient.query<GetCompanySharedFoldersQuery, GetCompanySharedFoldersQueryVariables>({
        query: getCompanySharedFolders,
        variables: {
          id
        }
      })
      commit(MutationTypes.GET_FOLDERS_SUCCESS, folders)
    } catch (err) {
      commit(MutationTypes.GET_FOLDERS_ERROR, err)
    }
  }
}
